import { createSlice } from "@reduxjs/toolkit";
import { deleteLocalEntry, storeLocally } from "../../utils/localStorage";

const initialState = {
  details: {},
  loggedIn: false,
  isAdmin: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.details = action.payload.details;
      state.loggedIn = action.payload.loggedIn;
      state.isAdmin = !!action.payload.details?.data?.admin;
      state.trial = action.payload.details?.data?.trial;
      state.auth = action.payload.auth;

      if (!action.payload.details?.id) {
        deleteLocalEntry("userId");
        deleteLocalEntry("Id");
      } else {
        storeLocally("userId", action.payload.details.id);
        storeLocally("Id", action.payload.details.id);
      }
      if (!action.payload.details?.data?.trial) {
        deleteLocalEntry("trial");
      } else {
        storeLocally("trial", action.payload.details?.data?.trial);
      }
      if (action.payload.auth) {
        storeLocally("auth", action.payload.auth);
      } else {
        deleteLocalEntry("auth");
      }
      if (action.payload.details?.data?.videos) {
        storeLocally("videos", action.payload.details?.data?.videos);
      }
    },
  },
});

export const { setUserDetails } = userSlice.actions;
export default userSlice.reducer;
